import { render } from "./RowPatientSummary.vue?vue&type=template&id=50370392&ts=true"
import script from "./RowPatientSummary.vue?vue&type=script&lang=ts"
export * from "./RowPatientSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__